module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-700.f4f17fd5.woff2";